import dayjs from 'dayjs';

export interface ResidentContact {
  id: string;
  name: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastMessageTime?: dayjs.Dayjs;
  unreadCount?: number;
}

export interface ChatMessage {
  id: string;
  senderId: 'currentUser' | string;
  recipientId: string;
  text: string;
  timestamp: dayjs.Dayjs;
  isRead?: boolean;
}

export const residentContacts: ResidentContact[] = [
  {
    id: 'res1',
    name: 'Elena Rodriguez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
    lastMessage: 'Vale, lo revisaré. ¡Gracias!',
    lastMessageTime: dayjs().subtract(15, 'minute'),
    unreadCount: 2,
  },
  {
    id: 'res2',
    name: 'Carlos Gomez',
    avatarUrl: 'https://randomuser.me/api/portraits/men/45.jpg',
    lastMessage: '¿Puedes reenviar el documento?',
    lastMessageTime: dayjs().subtract(1, 'hour'),
  },
  {
    id: 'res3',
    name: 'Sofia Fernandez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/33.jpg',
    lastMessage: 'Perfecto, nos vemos entonces.',
    lastMessageTime: dayjs().subtract(3, 'hour'),
    unreadCount: 0,
  },
  {
    id: 'res4',
    name: 'Luis Hernandez',
    lastMessage: 'Pago confirmado.',
    lastMessageTime: dayjs().subtract(1, 'day'),
  },
];

export const chatHistory: Record<string, ChatMessage[]> = {
  res1: [
    { id: 'msg1', senderId: 'res1', recipientId: 'currentUser', text: 'Hola, tengo una pregunta sobre mi último pago.', timestamp: dayjs().subtract(1, 'hour'), isRead: true },
    { id: 'msg2', senderId: 'currentUser', recipientId: 'res1', text: 'Hola Elena, claro, ¿cuál es tu pregunta?', timestamp: dayjs().subtract(55, 'minute'), isRead: true },
    { id: 'msg3', senderId: 'res1', recipientId: 'currentUser', text: 'Pensé que pagué por 2 meses, pero la aplicación solo muestra 1.', timestamp: dayjs().subtract(30, 'minute'), isRead: true },
    { id: 'msg4', senderId: 'currentUser', recipientId: 'res1', text: 'Déjame revisar eso por ti. Un momento por favor.', timestamp: dayjs().subtract(25, 'minute'), isRead: true },
    { id: 'msg5', senderId: 'currentUser', recipientId: 'res1', text: 'Vale, veo el problema. Fue un pequeño fallo del sistema, debería estar actualizado ahora. Por favor actualiza tu aplicación.', timestamp: dayjs().subtract(18, 'minute'), isRead: false },
    { id: 'msg6', senderId: 'res1', recipientId: 'currentUser', text: 'Vale, lo revisaré. ¡Gracias!', timestamp: dayjs().subtract(15, 'minute'), isRead: false },
  ],
  res2: [
    { id: 'msg7', senderId: 'res2', recipientId: 'currentUser', text: 'Buenos días, necesito una copia del documento de pautas de la comunidad.', timestamp: dayjs().subtract(2, 'hour') },
    { id: 'msg8', senderId: 'currentUser', recipientId: 'res2', text: 'Hola Carlos, lo he adjuntado a este mensaje.', timestamp: dayjs().subtract(1, 'hour').add(5, 'minute') },
    { id: 'msg9', senderId: 'res2', recipientId: 'currentUser', text: '¿Puedes reenviar el documento?', timestamp: dayjs().subtract(1, 'hour') },
  ],
  res3: [
    { id: 'msg10', senderId: 'res3', recipientId: 'currentUser', text: 'Hola, ¿está disponible la casa club para reservar el sábado?', timestamp: dayjs().subtract(5, 'hour') },
  ]
};
